import * as React from "react";
import { cloneElement } from "react";
import { TopToolbar, ExportButton, sanitizeListRestProps } from "react-admin";
import CreateButton from "../components/buttons/CreateButton";

const Actions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <CreateButton
      basePath={basePath}
      baseRecord={{ ...filterValues, user_id: null }}
    />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={{ ...filterValues, ...permanentFilter }}
      exporter={exporter}
      maxResults={maxResults}
    />
  </TopToolbar>
);

Actions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default Actions;
